import axios, { AxiosResponse } from 'axios';
import { makeApiUrl } from '../../../shared/util';
import {
  PatchPlusCreatorSortRequestBody,
  PlusCreatorResponseStatus,
  PostPlusLikeRequestBody,
  PostPlusLikeResponseBody,
} from '../type';

export const postPlusLike = (form: PostPlusLikeRequestBody) => {
  return axios.post<PostPlusLikeResponseBody>(makeApiUrl('/:lang/@api/plus/like', { lang: ET.lang }), form);
};

export const patchPlusCreatorSort = async (form: PatchPlusCreatorSortRequestBody, crew_id: number) => {
  const { data } = await axios.patch<
    PatchPlusCreatorSortRequestBody,
    AxiosResponse<PlusCreatorResponseStatus>
  >(makeApiUrl('/@api/crews/:crew_id/stores/:store_id/sort', { crew_id: `${crew_id}` }), form);
  return data;
};
